import { ReadonlyURLSearchParams } from 'next/navigation'

import { OutletDetailsURLFlag } from '../constants'

/**
 * Checks if the router URL search params contain only the outlet details flag.
 */
export default function hasOutletDetailsURLFlag(
  searchParams: ReadonlyURLSearchParams,
) {
  return searchParams.has(OutletDetailsURLFlag) && searchParams.size === 1
}
